import Image from "next/image";
import React from "react";
import assetLoader from "@utils/internalImageLoder";
import styles from "./FuelTypeBox.module.scss";
import { formatPrice } from "@utils/numberFormatter";

interface FuelTypeBoxProps {
  fuelType: string;
  minPrice: number;
  maxPrice: number;
  variants: number;
  onClick?: () => void;
}

export default function FuelTypeBox({
  fuelType,
  minPrice,
  maxPrice,
  variants,
  onClick,
}: FuelTypeBoxProps) {
  return (
    <div className={styles.box} onClick={onClick}>
      <p className={styles.fuelType}>{fuelType}</p>
      <div className={styles.details}>
        <p className={styles.price}>{`${formatPrice(
          minPrice
        )} – ${formatPrice(maxPrice)}`}</p>
        <div className={styles.variants}>
          {`${variants} variants`}
          <Image
            src={`${assetLoader()}/icons/Chevron_right.png`}
            alt="chevron"
            loading="lazy"
            width={16}
            height={16}
          />
        </div>
      </div>
    </div>
  );
}
